import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Hourglass, LogOut, Droplet } from "lucide-react";

export default function PendingPage() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="pending-page">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl p-8 shadow-[0_8px_24px_-6px_rgba(0,0,0,0.06)] text-center space-y-5">
        <div className="inline-flex h-14 w-14 rounded-full bg-amber-50 border border-amber-200 items-center justify-center mx-auto">
          <Hourglass className="h-7 w-7 text-amber-700" />
        </div>
        <div className="flex items-center justify-center gap-2 text-xs tracking-[0.2em] uppercase font-semibold text-sky-700">
          <Droplet className="h-3.5 w-3.5" />
          Lifjalla Analytics
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-slate-900">Wacht op goedkeuring</h1>
          <p className="text-sm text-slate-600 leading-relaxed">
            Hallo {user?.name?.split(" ")[0] || user?.email}. Je account is aangemeld met <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded">{user?.email}</span>, maar je hebt nog geen toegang tot de data.
          </p>
          <p className="text-sm text-slate-500">
            De eigenaar moet je manueel goedkeuren. Probeer over enkele uren opnieuw.
          </p>
        </div>
        <Button onClick={logout} variant="outline" className="w-full" data-testid="pending-logout-btn">
          <LogOut className="h-4 w-4 mr-2" /> Afmelden
        </Button>
      </div>
    </div>
  );
}
